import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment-jalaali';
import { CookieService } from 'ngx-cookie-service';
import { BaseRichService } from '../../../providers/base-rich.service';
import { BaseFormComponent } from '../../shared/base-form/base-form.component';

@Component({
  selector: 'app-issue-form',
  templateUrl: '../../shared/base-form/base-form.component.html',
  styleUrls: ['./issue-form.component.scss', '../../shared/base-form/base-form.component.scss']
})
export class IssueFormComponent extends BaseFormComponent implements OnInit {
  allTypes;

  constructor(public cookieService: CookieService,
    public activeModal: NgbActiveModal,
    public titleService: Title,
    public translator: TranslateService,
    public service: BaseRichService,
    public route: ActivatedRoute,
    public router: Router
  ) {
    super(cookieService, activeModal, titleService, translator, service);
    this.entityName = 'issue';
  }

  async ngOnInit() {
    await super.ngOnInit();
    if (!this.isEdit) {
      this.allTypes = await this.service.apiCall('api/issue/types', { selectedAccount: this.selectedAccount }).toPromise();
    }
    if (JSON.stringify(this.route.snapshot.data) !== '{}') {
      await this.initType(this.route.snapshot.data);
    }
    else if (this.params && JSON.stringify(this.params) !== '{}') {
      await this.initType(this.params);
    } else {
      this.route.params.subscribe(async params => {
        await this.initType(params);
      });
    }
  }

  async customize(field) {
    this.initField(field);
    if (['department', 'type'].includes(field.name)) {
      field.type.readOnly = this.isEdit;
    }

    if (field.name === 'type' && this.isEdit) {
      this.allTypes = await this.service.apiCall('api/issue/type', { type: this.formData.type }).toPromise();
      field.type.options = this.allTypes.map(t => ({ value: t.value, name: t.name }));
      if (this.formData.type) {
        await this.changeType(this.formData.type);
      }
    }
    await super.customize(field);

  }

  async manipulate(e) {
    if (this.isEdit) {
      if (e.data.timeframe_from && e.data.timeframe_from < '1900') {
        e.data.timeframe_from = moment(e.data.timeframe_from, 'jYYYY-jMM-jDD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
      }

      if (e.data.timeframe_to && e.data.timeframe_to < '1900') {
        e.data.timeframe_to = moment(e.data.timeframe_to, 'jYYYY-jMM-jDD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
      }

    }
    Object.assign(e, e.data);
  }

  async initType(params) {
    if (params.subentity && params.subentity.includes('.')) {
      this.formData.type = params.subentity;
      params.department = params.subentity.split('.')[0];
      params.type = params.subentity.split('.')[1];
    }
    if (params.department) {
      const departmentField = this.fields.find(f => f.name === 'department');
      departmentField.value = params.department;
      this.changeDisabled('department', true);
      await this.customize(departmentField);
      setTimeout(async () => {
        if (params.type) {
          const typeField = this.fields.find(f => f.name === 'type');
          typeField.value = `${params.department}.${params.type}`;
          this.changeDisabled('type', true);
          await this.customize(typeField);
          if (params.data) {
            setTimeout(() => {
              for (const d of Object.keys(params.data)) {
                this.formData[d] = params.data[d];
              }
            }, 1000);
          }
        }
      }, 1000);
    }

    if (params.defaultDepartment) {
      this.changeValue('department', params.defaultDepartment);
      if (params.defaultType) {
        setTimeout(() => {
          this.changeValue('type', `${params.defaultDepartment}.${params.defaultType}`);
        }, 1000);
      }
    }

    if (params.description) {
      this.changeValue('description', params.description);
    }

    if (params.ref) {
      this.formData['ref'] = params.ref;
    }

  }

  valueChanged = async (e) => {
    await super.valueChanged(e);
    switch (e.element.id) {
      case 'department':
        await this.changeDepartment(e.value);
        break;
      case 'type':
        await this.changeType(e.value);
        break;
      case 'ref':
        const ref = this.fields.find(f => f.name === 'ref');
        if (ref && ref.type.option && ref.type.option.api && ref.type.option.value && e.value && e.value.length > 3) {
          let fields = [];
          switch (ref.type.option.api) {
            case 'api/account/read':
              fields = [
                'name',
                'family',
                'gender',
                'father_name',
                'address',
                'postal_code',
                'identification_type',
                'identification_no',
                'certificate_no',
                'birth_date',
                'company_type',
                'economic_code',
                'person_type_fa',
                'email'
              ];
              break;
            default:
              break;
          }
          const result = await this.service.apiCall(ref.type.option.api, {
            fields,
            query: [ref.type.option.value, '=', e.value],
            raw: true
          }).toPromise();
          if (result.length) {
            Object.assign(this.formData, result[0]);
          }
        }
        break;
      default:
        break;
    }
  }

  async changeDepartment(value) {
    if (!this.isEdit) {
      this.formData['type'] = null;
      const types = this.allTypes
        .filter(t => t.value.split('.')[0] === value)
        .filter(t => this.params && this.params.entity ? t.entity === this.params.entity : true)
        .map(t => ({ value: t.value, name: t.name }));
      this.changeDataSource('type', types);
    }
  }

  async changeType(value) {
    if (value) {
      if (!this.isEdit) {
        this.formData['subject'] = null;
      }
      this.fields = this.fields.filter(f => f.primary);
      const subjectField = this.fields.find(f => f.name === 'subject');
      const descriptionField = this.fields.find(f => f.name === 'description');
      const departmentField = this.fields.find(f => f.name === 'department');
      const typeField = this.fields.find(f => f.name === 'type');
      const severityField = this.fields.find(f => f.name === 'severity');
      // const priorityField = this.fields.find(f => f.name === 'priority');

      if (value) {
        const type = this.allTypes.find(t => t.value === value);
        this.title = type.name;
        this.info = type.info;
        if (this.activeModal.close.toString().includes('{}')) {
          this.colCount = type.colCount || this.colCount;
          this.hiddenReset = true;
        }
        this.body.entity = this.params && this.params.entity ? this.params.entity : type.entity;

        if (this.params && this.params.ref) {
          this.body.ref = this.params.ref;
        }

        if (this.body.entity === 'ACCOUNT.SELF') {
          this.body.entity = 'ACCOUNT';
          if (!this.isEdit) {
            this.body.ref = this.selectedAccount || this.username;
          }
        }

        if (type.subjects && type.subjects.length) {
          subjectField.type.name = 'select-simple';
          subjectField.type.searchable = true;
          subjectField.type.options = type.subjects;
        } else {
          subjectField.type.name = 'text';
          subjectField.value = type.name;
        }

        if (type.optional_description) {
          descriptionField.rules = [];
        }
        if (type.template) {
          for (const field of type.template) {
            if (field.name === 'ref') {
              if (this.params && this.params.entity && type.entity !== this.params.entity) {
                field.type.name = 'hidden';
              } else if (this.isEdit) {
                field.type.name = 'text';
              } else if (this.params && this.params.ref) {
                field.value = this.params.ref;
              }
            }
            await this.customize(field);
          }
          this.fields = this.fields.concat(type.template);
        }
        if (descriptionField) { descriptionField.hidden = type.compact; }
        if (subjectField) { subjectField.hidden = type.compact; }
        if (departmentField) { departmentField.hidden = type.compact; }
        if (typeField) { typeField.hidden = type.compact; }
        if (severityField) { severityField.hidden = type.compact; }
        // if (priorityField) { priorityField.hidden = type.compact; }

      } else {
        subjectField.type.name = 'text';
        subjectField.value = '';
      }

      await this.customize(subjectField);
    }

  }

  afterSave(body) {
    super.afterSave(body);
    if (this.hiddenCancel) {
      if (this.selectedAccount) {
        if (body.entity === 'USER') {
          this.router.navigate([`/user/${body.ref}`]);
        } else {
          this.router.navigate([`/dashboard`]);
        }
      } else if (this.token) {
        this.router.navigate([`/issue/by-me`]);
      } else {
        this.router.navigate([`/`]);
      }
    }
  }

}
